<template>
  <v-snackbar v-model="show" right :color="color">
    {{ message }}
    <v-btn text @click="clearMessage">OK</v-btn>
  </v-snackbar>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  data() {
    return {
      show: false
    }
  },

  computed: {
    ...mapState({
      showMessage: state => state.alert.show,
      message: state => state.alert.message,
      color: state => state.alert.color
    })
  },

  watch: {
    showMessage() {
      this.show = this.showMessage
    },
    show() {
      if (this.show === false) {
        this.clearMessage()
      }
    }
  },

  methods: {
    ...mapMutations({
      clearMessage: 'alert/clearMessage'
    })
  }
}
</script>

<style lang="scss" scoped></style>
